import { render, staticRenderFns } from "./_coming-soon.tab.vue?vue&type=template&id=67d68cc2&scoped=true"
import script from "./_coming-soon.tab.vue?vue&type=script&lang=js"
export * from "./_coming-soon.tab.vue?vue&type=script&lang=js"
import style0 from "./_coming-soon.tab.vue?vue&type=style&index=0&id=67d68cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d68cc2",
  null
  
)

export default component.exports